import confirmationActionTypes from './confirmation.actionTypes.js';

export function showConfirmationModal (data = {}) {
  return {type: confirmationActionTypes.SHOW_CONF_MODAL, data};
}

export function dismissConfirmationModal (callback) {
  return dispatch => {
    callback && callback();
    dispatch(dismissModal());
  };
}

export function confirm (callback) {
  return (dispatch, getState) => {
    let data = getState().confirmationModal.data;
    callback && callback(data);
    dispatch(dismissModal());
  };
}

function dismissModal () {
  return {type: confirmationActionTypes.DISMISS_CONF_MODAL};
}
